import { Banner } from 'flowbite-react';
import { PropsWithChildren } from 'react';
import { HiX } from 'react-icons/hi';
import { MdAnnouncement } from 'react-icons/md';

type ShrtBannerProps = {};

export default function ShrtBanner({ children }: PropsWithChildren<ShrtBannerProps>) {
  return (
    <Banner>
      <div className="flex w-full justify-between border-b border-gray-200 bg-gray-50 p-4 dark:border-gray-600 dark:bg-gray-700">
        <div className="mx-auto flex items-center">
          <p className="flex items-center text-sm font-normal text-gray-500 dark:text-gray-400">
            <MdAnnouncement className="mr-4 h-4 w-4" />
            <span className="[&_p]:inline">{children}</span>
          </p>
        </div>
        <Banner.CollapseButton color="gray" className="border-0 bg-transparent text-gray-500 dark:text-gray-400">
          <HiX className="h-4 w-4" />
        </Banner.CollapseButton>
      </div>
    </Banner>
  );
}
